import React from "react";
import { useExperiments } from "@wix/fe-essentials-standalone";
import { WIX_URL } from "./consts";
import { MiddleScreenLoader } from "./landingPage/components/Common/MiddleScreenLoader";

export const MainApp = ({ children }: { children: React.ReactNode }) => {
  const { experiments } = useExperiments();
  const isLocalEnv = process.env.NODE_ENV === "development";
  const isProductionModeEnabled =
    experiments.enabled("picasso.production-mode") ||
    experiments.enabled("specs.wixvibe.production-show") ||
    isLocalEnv;

  React.useEffect(() => {
    if (!isProductionModeEnabled) {
      window.open(WIX_URL, "_self");
    }
  }, [isProductionModeEnabled]);

  return isProductionModeEnabled ? children : <MiddleScreenLoader />;
};
